import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Redirect } from "react-router-dom";
import Sidebar from "../Dashboard/Sidebar/Sidebar";
import styling from "../Dashboard/Dashboard.module.css";
import Navbar from "../Dashboard/Navbar/Navbar";
import firebase from "../../firebase/firebase";
// import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import Home from "../Dashboard/Content/Home/Home";
import AddItem from "../Dashboard/Content/AddItem/AddItem";
import AddSuppliers from "../Dashboard/Content/AddSuppliers/AddSuppliers";
import MyStocks from "../Dashboard/Content/MyStocks/MyStocks";
import PurchaseItem from "../Dashboard/Content/PurchaseItem/PurchaseItem";
import SellItem from "../Dashboard/Content/SellItem/SellItem";
import Registration from "../RegisterShop/Registration/Registration";
import Customers from "../Dashboard/Content/Customers/Customers";
import AddChannel from "../Dashboard/AddChannels/AddChannels";
import { useEffect } from "react";
import {
  shopDetails,
  salesItem,
  salesItemRemove,
  customerItems,
  allCustomers,
  removeAllCustomers,
  salesChannelAction,
  removeSalesChannel,
  shopSalesHistory,
  removeShopSalesHistory,
  userDetails,
  removeAllCustomerItems,
  clearShopDetails,
  deleteCustomer,
  // isLoggedIn,
  // clearShopDetails,
} from "../../redux/actions/actions";

function Dashboard() {
  const location = useLocation();
  const history = useHistory();
  let dispatch = useDispatch();
  let loggedIn = useSelector((state) => state.isLogged);
  let [activeStatus, setActiveStatus] = useState(() => {
    const saved = localStorage.getItem("activeStatus");
    return saved || "Home"; // fallback
  });
  let [showSidebar, setShowSidebar] = useState(true);
  let [showAddChannel, setShowAddChannel] = useState(false);
  // let [guestUser, setGuestUser] = useState(false);
  const guestUser = location.pathname === "/demo";
  // useEffect(() => {
  //   if (loggedIn) {
  //     console.log("loggedIn", loggedIn);
  //     history.push("/dashboard");
  //   }
  // }, [loggedIn, history]);

  useEffect(() => {
    if (window.innerWidth < 780) {
      setShowSidebar(false);
    }
  }, []);
  useEffect(() => {
    if (showSidebar && window.innerWidth < 780) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showSidebar]);

  // useEffect(() => {
  //   if (loggedIn) {
  //     return <Redirect to="/dashboard" />;
  //   }
  // }, [loggedIn]);

  useEffect(() => {
    if (loggedIn) return;
    if (!guestUser) return;
    let myShopDetails = {
      shopName: "Demo Shop",
      shopAddress: "123, Demo Street, Demo City",
      shopPhone: "1234567890",
      shopMail: "demo@demo.com",
      shopOwnerName: "Demo Owner",
      shopOwnerPasscode: "1234",
    };
    dispatch(shopDetails(myShopDetails));
    const items = {
      aata: {
        costPrice: 10,
        itemName: "aata",
        measurment: "kg",
        quantity: 66,
        sellingPrice: 20,
        price: 20,
      },

      biscuit: {
        costPrice: 40,
        itemName: "biscuit",
        measurment: "pieces",
        quantity: 76,
        sellingPrice: 50,
        price: 50,
      },

      dal: {
        costPrice: 34,
        itemName: "dal",
        measurment: "kg",
        quantity: 35,
        sellingPrice: 67,
        price: 67,
      },

      rice: {
        costPrice: 20,
        itemName: "rice",
        measurment: "kg",
        quantity: 23,
        sellingPrice: 25,
        price: 25,
      },

      tofee: {
        costPrice: 1,
        itemName: "tofee",
        measurment: "pieces",
        quantity: 23,
        sellingPrice: 2,
        price: 2,
      },
    };
    dispatch(salesItem(items));
    let itemCart = [
      {
        ...items["aata"],
        quantity: 2,
        price: 40,
      },
      {
        ...items["biscuit"],
        quantity: 1,
      },
      {
        ...items["tofee"],
        quantity: 1,
      },
    ];
    dispatch(customerItems(itemCart));
    let customers = {};
    let customerPhone = "9870682030";
    let customerName = "Demo Customer";
    customers[customerPhone] = { customerName, customerPhone };
    dispatch(allCustomers(customers));
    let salesChannel = {
      amazon: "https://www.facebook.com/suhelhasan11/",
      facebook: "https://www.facebook.com/suhelhasan11/",
      instagram: "https://www.instagram.com/suhelhasan_/",
      youtube: "https://www.instagram.com/suhelhasan_/",
    };
    dispatch(salesChannelAction(salesChannel));
    const sellingHistory = {
      "2025-11-29": {
        "Sat Nov 29 2025 11:09:35 GMT+0530 (India Standard Time)": [
          {
            itemName: "biscuit",
            measurment: "pieces",
            price: 150,
            quantity: 1,
            sellingPrice: 150,
          },
        ],

        "Sat Nov 29 2025 11:51:13 GMT+0530 (India Standard Time)": [
          {
            itemName: "biscuit",
            measurment: "pieces",
            price: 150,
            quantity: 1,
            sellingPrice: 150,
          },
        ],

        "Sat Nov 29 2025 11:52:01 GMT+0530 (India Standard Time)": [
          {
            itemName: "biscuit",
            measurment: "pieces",
            price: 20,
            quantity: 1,
            sellingPrice: 20,
          },
        ],

        "Sat Nov 29 2025 11:52:25 GMT+0530 (India Standard Time)": [
          {
            itemName: "biscuit",
            measurment: "pieces",
            price: 20,
            quantity: 1,
            sellingPrice: 20,
          },
        ],

        "Sat Nov 29 2025 11:54:41 GMT+0530 (India Standard Time)": [
          {
            itemName: "biscuit",
            measurment: "pieces",
            price: 20,
            quantity: 6,
            sellingPrice: 20,
          },
        ],

        "Sat Nov 29 2025 17:49:40 GMT+0530 (India Standard Time)": [
          {
            itemName: "tomato",
            measurment: "kg",
            price: 120,
            quantity: 1,
            sellingPrice: 120,
          },
          {
            itemName: "biscuit",
            measurment: "pieces",
            price: 20,
            quantity: 1,
            sellingPrice: 20,
          },
        ],
      },
      "2025-12-02": {
        "Tue Dec 02 2025 11:51:41 GMT+0530 (India Standard Time)": [
          {
            itemName: "dal",
            measurment: "kg",
            price: 67,
            quantity: 5,
            sellingPrice: 67,
          },
        ],
        "Tue Dec 02 2025 11:54:41 GMT+0530 (India Standard Time)": [
          {
            itemName: "rice",
            measurment: "kg",
            price: 25,
            quantity: 20,
            sellingPrice: 25,
          },
        ],
        "Tue Dec 02 2025 11:58:41 GMT+0530 (India Standard Time)": [
          {
            itemName: "tofee",
            measurment: "pieces",
            price: 2,
            quantity: 5,
            sellingPrice: 2,
          },
        ],
      },
    };
    dispatch(shopSalesHistory(sellingHistory));
    let userInfo = {
      name: "Guest User",
      phone: "9870682030",
      email: "demo@example.com",
    };
    dispatch(userDetails(userInfo));

    return () => {
      // dispatch(userDetails());
      dispatch(removeShopSalesHistory({}));
      dispatch(removeSalesChannel({}));
      dispatch(removeAllCustomerItems([]));
      dispatch(clearShopDetails({}));
      dispatch(deleteCustomer({}));
      dispatch(salesItemRemove({}));
    };
  }, [dispatch, guestUser, loggedIn]);

  let toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };
  const componentMap = {
    AddItem,
    AddSuppliers,
    MyStocks,
    PurchaseItem,
    SellItem,
    Registration,
    Customers,
    Home,
  };
  const ActiveComponent = componentMap[activeStatus] || Home;

  function changeComponent(key) {
    localStorage.setItem("activeStatus", key || "Home");
    setActiveStatus(key || "Home");
    if (window.innerWidth < 780) {
      toggleSidebar();
    }
  }
  function toggleAddChannel() {
    setShowAddChannel(!showAddChannel);
  }

  return (
    <>
      <div className={styling.Dashboard}>
        {showSidebar ? (
          <div className={styling.sidebarSection}>
            <Sidebar
              showAddChannel={() => toggleAddChannel()}
              toggleComponent={changeComponent}
              activeStatus={activeStatus}
              guestUser={guestUser}
            />
          </div>
        ) : null}
        <div
          className={
            showSidebar ? styling.mainSection : styling.mainSectionAddition
          }
        >
          <div
            className={
              showSidebar ? styling.mainNavbar : styling.mainNavbarAddition
            }
          >
            <Navbar
              toggleSidebar={toggleSidebar}
              guestUser={guestUser}
              showSidebar={showSidebar}
            />
          </div>

          <div className={styling.multipleComponents}>
            <ActiveComponent guestUser={guestUser} />
          </div>
        </div>
      </div>
      {showAddChannel ? (
        <AddChannel toggleChannel={toggleAddChannel} guestUser={guestUser} />
      ) : null}
    </>
  );
}

export default Dashboard;
